import styles from "./Paper.module.css"
import { ReactNode } from "react"
import cs from "clsx"

interface Props {
  children: ReactNode | ReactNode[]
  className?: string
}
export function Paper({ children, className }: Props) {
  return <div className={cs(styles.root, className)}>{children}</div>
}
